import { CrudList } from '../shared/CrudPage';
import { salesReturnService } from '@kss/api';
import type { SalesReturn, SalesReturnCreate, SalesReturnFilter } from '@kss/api';

export default function AllSalesReturns() {
  return (
    <CrudList<SalesReturn, SalesReturnCreate, SalesReturnFilter>
      title="Sales Returns"
      newLabel="New sales return"
      service={salesReturnService}
      idKey="salesReturnId"
      labelKey="name"
      basePath="/panel/sales-returns"
      columns={[
        { accessor: 'code', title: 'Return #', width: 140, filterable: true },
        { accessor: 'salesOrderId' as never, title: 'Order', width: 180 },
        { accessor: 'customerId' as never, title: 'Customer', width: 180 },
        { accessor: 'returnDate' as never, title: 'Date', width: 120 },
        { accessor: 'refundAmount' as never, title: 'Refund', width: 120 },
      ]}
    />
  );
}
